<script>
  let {
    title,
    subtitle,
    steps,
  } = $props();
</script>

<section class="border-b border-[#3a3a4a]">
  <div class="max-w-5xl mx-auto px-4 py-16">
    <div class="text-center mb-12">
      <p class="text-[#888890] text-xs uppercase tracking-widest mb-3">── HOW IT WORKS ──</p>
      <h2 class="text-2xl md:text-3xl font-bold text-[#e8e8ec] mb-4">
        {title}
      </h2>
      <p class="text-[#a0a0a8] max-w-2xl mx-auto text-sm leading-relaxed">
        {subtitle}
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-4">
      {#each steps as step}
        <div class="p-5 border border-[#3a3a4a] bg-[#101018] hover:border-[#a855f7] transition-colors">
          <div class="text-2xl font-bold text-[#a855f7] mb-3">
            {step.number}
          </div>
          <h3 class="text-lg font-bold text-[#d8d8dc] mb-2">
            {step.title}
          </h3>
          <p class="text-[#909098] text-sm leading-relaxed">
            {step.description}
          </p>
        </div>
      {/each}
    </div>
  </div>
</section>
